module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "breadcrumb-arrow.f86571c5.svg";